/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Notification.style';
import NotificationBanner from 'src/shared/ui/component/messaging/NotificationBanner';

import { portalNotificationId } from 'src/shared/app/base/constant/domConstants';
import Portal from 'src/shared/ui/component/misc/Portal';
import NoSsr from '@mui/material/NoSsr';

type Props = {
  timeout?: number,
  layoutClass?: string,
  withWarning?: boolean,
  withError?: boolean,
  href?: string,
  icon?: React.Node,
  handleDismiss?: () => void,
  children: React.Node,
  isCentered?: boolean,
};

const useStyles = createUseThemeStyles(styles);

let timeoutId: number;

const Notification = ({
  withWarning,
  withError,
  href,
  icon,
  timeout,
  handleDismiss,
  children,
  isCentered,
}: Props): React.Node => {
  React.useEffect(() => {
    if (timeout) {
      timeoutId = window.setTimeout(handleDismiss, timeout);
    }

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  const classes = useStyles();

  return (
    <NoSsr>
      <Portal id={portalNotificationId}>
        <div className={classes.root}>
          <NotificationBanner
            withWarning={withWarning}
            withError={withError}
            href={href}
            icon={icon}
            handleDismiss={handleDismiss}
            isCentered={isCentered}
          >
            {children}
          </NotificationBanner>
        </div>
      </Portal>
    </NoSsr>
  );
};

export default React.memo<Props>(Notification);
